import * as app from './app'

app.bootstrapApplication({ routes: app.ROUTES })
